import React from 'react';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

const SrImageNotFound = () => (
  <SrBox
    width="100%"
    height="100%"
    position="relative"
    backgroundColor="#8A8A8A"
    borderRadius="14px"
    display="flex"
    flexDirection="row"
    flexWrap="wrap"
    justifyContent="center"
    alignItems="center"
  >
    <SrBox
      width="240px"
      height="120px"
      backgroundImage="url(/images/photo-not-found.svg)"
      backgroundPosition="center 20px"
      backgroundRepeat="no-repeat"
      position="relative"
    >
      <SrBox position="relative" top="55px" left="60px">
        <SrText font="greycliff" size="16" weight="bold" color="white">
          Photo not found
        </SrText>
      </SrBox>
    </SrBox>
  </SrBox>
);

SrImageNotFound.displayName = 'SrImageNotFound';

export default SrImageNotFound;
